import React from 'react';
import MediaImage from './MediaImage';

type EntityLogoProps = {
  src?: string | null;
  alt: string;
  className?: string;
  /** Square logo tile — cover after server-side trim/normalize. */
  rounded?: 'full' | 'lg' | 'none';
};

/**
 * Club/shop/event logos — square crop, cover fill, dark plate for transparent marks.
 */
export const EntityLogo: React.FC<EntityLogoProps> = ({
  src,
  alt,
  className = '',
  rounded = 'lg',
}) => {
  const radius =
    rounded === 'full' ? 'rounded-full' : rounded === 'lg' ? 'rounded-lg' : 'rounded-none';

  return (
    <div
      className={`overflow-hidden bg-[#141414] border border-white/[0.06] ${radius} ${className}`}
    >
      <MediaImage src={src} alt={alt} fit="cover" loading="lazy" className="w-full h-full" />
    </div>
  );
};

export default EntityLogo;
